"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingInfo = exports.DownPayment = exports.MonthlyPayment = exports.Price = exports.TrimMileage = exports.YearMakeModel = exports.VehicleImage = exports.VehicleInfoContainer = void 0;
var merch_components_1 = require("@carvana/merch-components");
var CommonElement = (0, merch_components_1.createComponent)('span', {
    className: 'overflow-hidden bg-grey-1'
});
exports.VehicleInfoContainer = (0, merch_components_1.createComponent)('div', {
    className: 'grid grid-cols-1 grid-rows-[44px_1fr_16px] px-16 py-12'
});
exports.VehicleImage = (0, merch_components_1.createComponent)('div', {
    className: 'w-full bg-gradient-to-t from-[#EDF5F8] via-white to-white'
});
exports.YearMakeModel = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'h-24 w-[60%]'
});
exports.TrimMileage = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'h-20 w-[40%]'
});
exports.Price = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'mb-20 h-28 w-[50%]'
});
exports.MonthlyPayment = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'mb-4 h-20 w-80'
});
exports.DownPayment = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'mb-20 h-20 w-[100px]'
});
exports.ShippingInfo = (0, merch_components_1.createComponent)(CommonElement, {
    className: 'h-16 w-[80%]'
});
//# sourceMappingURL=LoadingTile.styles.js.map